import type { Template } from "@/types";

export const PO_07_H4_V3: Template[] = [
{
    id: "po-07-h4v3-01",
    name: "PO 01 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_01.png",
    size: [1217, 851],
    style: {},
        slots: [       
            { id: "1", x: 43, y: 232, width: 260, height: 190, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 430, width: 260, height: 190, rotation: 0, imageRotation: 0 },
            { id: "3", x: 311, y: 232, width: 260, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 311, y: 430, width: 260, height: 190, rotation: 0, imageRotation: 0 },
            { id: "5", x: 650, y: 156, width: 349, height: 539, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1007, y: 156, width: 170, height: 266, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1007, y: 430, width: 170, height: 265, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h4v3-02",
    name: "PO 02 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 75, y: 173, width: 471, height: 333, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 75, y: 514, width: 232, height: 164, rotation: 0, imageRotation: 0 },
        { id: "3", x: 315, y: 514, width: 232, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 668, y: 125, width: 493, height: 346, rotation: 0, imageRotation: 0 },
        { id: "5", x: 668, y: 479, width: 160, height: 247, rotation: 0, imageRotation: 0 },
        { id: "6", x: 836, y: 479, width: 159, height: 247, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1003, y: 479, width: 159, height: 247, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-03",
    name: "PO 03 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 47, y: 247, width: 514, height: 357, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 654, y: 247, width: 168, height: 114, rotation: 0, imageRotation: 0 },
        { id: "3", x: 654, y: 369, width: 168, height: 114, rotation: 0, imageRotation: 0 },
        { id: "4", x: 654, y: 491, width: 168, height: 113, rotation: 0, imageRotation: 0 },
        { id: "5", x: 830, y: 247, width: 216, height: 357, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1054, y: 247, width: 117, height: 175, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1054, y: 430, width: 117, height: 174, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-04",
    name: "PO 04 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 47, y: 166, width: 505, height: 397, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 47, y: 571, width: 163, height: 112, rotation: 0, imageRotation: 0 },
        { id: "3", x: 218, y: 571, width: 163, height: 112, rotation: 0, imageRotation: 0 },
        { id: "4", x: 389, y: 571, width: 163, height: 112, rotation: 0, imageRotation: 0 },
        { id: "5", x: 641, y: 144, width: 359, height: 563, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1008, y: 144, width: 173, height: 278, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1008, y: 430, width: 173, height: 277, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-05",
    name: "PO 05 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 96, y: 222, width: 416, height: 265, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 96, y: 495, width: 205, height: 134, rotation: 0, imageRotation: 0 },
        { id: "3", x: 309, y: 495, width: 204, height: 134, rotation: 0, imageRotation: 0 },
        { id: "4", x: 716, y: 222, width: 395, height: 202, rotation: 0, imageRotation: 0 },
        { id: "5", x: 716, y: 432, width: 127, height: 197, rotation: 0, imageRotation: 0 },
        { id: "6", x: 851, y: 432, width: 126, height: 197, rotation: 0, imageRotation: 0 },
        { id: "7", x: 985, y: 432, width: 126, height: 197, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-06",
    name: "PO 06 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 43, y: 221, width: 528, height: 285, rotation: 0, imageRotation: 0 },
        { id: "2", x: 43, y: 513, width: 171, height: 116, rotation: 0, imageRotation: 0 },
        { id: "3", x: 222, y: 513, width: 171, height: 116, rotation: 0, imageRotation: 0 },
        { id: "4", x: 401, y: 513, width: 170, height: 116, rotation: 0, imageRotation: 0 },
        { id: "5", x: 707, y: 221, width: 261, height: 407, rotation: 0, imageRotation: 0 },       
        { id: "6", x: 976, y: 222, width: 127, height: 199, rotation: 0, imageRotation: 0 },
        { id: "7", x: 976, y: 429, width: 127, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-07",
    name: "PO 07 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 22, y: 221, width: 567, height: 407, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 626, y: 221, width: 187, height: 131, rotation: 0, imageRotation: 0 },
        { id: "3", x: 626, y: 360, width: 187, height: 130, rotation: 0, imageRotation: 0 },
        { id: "4", x: 626, y: 498, width: 187, height: 130, rotation: 0, imageRotation: 0 },
        { id: "5", x: 821, y: 221, width: 247, height: 407, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1076, y: 221, width: 118, height: 200, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1076, y: 429, width: 118, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-08",
    name: "PO 08 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 245, width: 237, height: 361, rotation: 0, imageRotation: 0 },
        { id: "2", x: 245, y: 245, width: 237, height: 177, rotation: 0, imageRotation: 0 },
        { id: "3", x: 245, y: 430, width: 237, height: 176, rotation: 0, imageRotation: 0 },
        { id: "4", x: 490, y: 245, width: 237, height: 361, rotation: 0, imageRotation: 0 },       
        { id: "5", x: 735, y: 245, width: 237, height: 177, rotation: 0, imageRotation: 0 },
        { id: "6", x: 735, y: 430, width: 237, height: 176, rotation: 0, imageRotation: 0 },
        { id: "7", x: 980, y: 245, width: 237, height: 361, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-09",
    name: "PO 09 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 238, width: 237, height: 184, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 430, width: 237, height: 183, rotation: 0, imageRotation: 0 },
        { id: "3", x: 245, y: 238, width: 237, height: 375, rotation: 0, imageRotation: 0 },
        { id: "4", x: 490, y: 238, width: 237, height: 375, rotation: 0, imageRotation: 0 },
        { id: "5", x: 735, y: 238, width: 237, height: 375, rotation: 0, imageRotation: 0 },     
        { id: "6", x: 980, y: 238, width: 237, height: 184, rotation: 0, imageRotation: 0 },
        { id: "7", x: 980, y: 430, width: 237, height: 183, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h4v3-10",
    name: "PO 10 - H4V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h4_v3_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 96, y: 122, width: 441, height: 299, rotation: 0, imageRotation: 0 },
        { id: "2", x: 96, y: 429, width: 441, height: 299, rotation: 0, imageRotation: 0 },
        { id: "3", x: 545, y: 122, width: 441, height: 299, rotation: 0, imageRotation: 0 },
        { id: "4", x: 545, y: 429, width: 441, height: 299, rotation: 0, imageRotation: 0 },
        { id: "5", x: 994, y: 122, width: 127, height: 197, rotation: 0, imageRotation: 0 },
        { id: "6", x: 994, y: 327, width: 127, height: 197, rotation: 0, imageRotation: 0 },
        { id: "7", x: 994, y: 532, width: 127, height: 196, rotation: 0, imageRotation: 0 }
    ],
}
];